import React, { useContext, useState } from 'react';
import { Event, updateEventDetails, EventStatus } from '../../../../../../model/event';
import { Button } from '../../../../../../components/Button/Button';
import { handleError } from '../../../../../../model/notification';
import { isAdmin, useSelectedMembership } from '../../../../../../model/membership';
import { t } from '../../../../../../locales/translate';
import { Stack } from '../../../../../../components/Stack/Stack';
import { ActivitiesContext } from '../../../../../../components/Activities/Activities';

interface Props {
  event: Event;
}

export function StatusInReview({ event }: Props): JSX.Element {
  const [loading, setLoading] = useState(false);
  const membership = useSelectedMembership();
  const { reloadActivities } = useContext(ActivitiesContext);

  async function setStatus(status: EventStatus): Promise<void> {
    setLoading(true);
    try {
      await updateEventDetails({ eventId: event.id, changes: { status } });
      reloadActivities();
    } catch (error) {
      handleError(error);
    }
    setLoading(false);
  }

  return (
    <div className="event-status__in-review">
      <Stack className="event-status__details">
        <div className="event-status__title">{t.model.status.inReview}</div>
        <div>{t.model.event.inReviewMsg}</div>
        {event.$permissions.includes('start_sale') && isAdmin(membership) && (
          <div className="event-status__actions">
            <Button
              title={t.model.sale.startSale}
              type="primary"
              onClick={() => setStatus('on_sale')}
              loading={loading}
            />
          </div>
        )}
      </Stack>
    </div>
  );
}
